(function() {
    var IGV = '36';
    var SEC = '';
    var FORM = '';
    var ANCHOR = '.stroller-product-images__slider-main';
    var CAP = 0.92;
    var PID = null;
    var SCALES = [1, 0.92, 0.84, 0.76, 0.68];
    var VENDOR_SEL = '[class*="klaviyo"], [id*="klaviyo"], [class*="kl-private"], [role="dialog"][aria-modal="true"], dialog[open]';
    var GENERIC_SEL = 'div, section, aside, iframe, dialog';
    var klOpen = false;
    var klOpenAt = 0;
    var vhLock = 0;
    var vhMin = 0;
    // Debug state. Every gate the box passes through records itself here so
    // window.igBuyboxDebug() can report exactly where it stopped.
    var DBG = {
        stage: 'script-loaded', // targeted → waiting → building → built | skipped | gave-up | build-error
        skipReason: '',
        tries: 0,
        waiting: null,
        awayCulprit: '',
        buildError: ''
    };
    var NUDGE = {
        '9188898275512': 24,
        '9209172394168': 24,
        '9209196773560': 24,
        '9191504314552': 24,
        '7358663131320': 24,
        '9994601857208': 34,
        '9994604347576': 34,
        '10135358636216': 34,
        '10135366238392': 34
    };
    var MERGE = {
        '9209172394168': 1,
        '9209196773560': 1,
        '9188898275512': 1,
        '9191504314552': 1,
        '7358663131320': 1,
        '9233362518200': 1,
        '9233396072632': 1,
        '9994601857208': 1,
        '9994604347576': 1,
        '10135358636216': 1,
        '10135366238392': 1,
        '10353197908152': 1,
        '10353198137528': 1,
        '10362924728504': 1,
        '10362954285240': 1,
        '10361352978616': 1,
        '10510775025848': 1,
        '10509850083512': 1
    };
    var COLOURWAY = {
        cardGap: 10,
        optsGap: 10,
        rowGap: 8,
        thumb: 12,
        titleFs: 3.5,
        priceFs: 21,
        swatch: 4.8,
        pillPv: 6,
        pillPh: 12,
        pillFs: 12,
        atcPv: 1.8,
        atcFs: 2.8
    };
    var COLOURWAY_ROOMY = {
        cardGap: 14,
        optsGap: 16,
        rowGap: 10,
        thumb: 12,
        titleFs: 3.5,
        priceFs: 21,
        swatch: 4.8,
        pillPv: 7,
        pillPh: 13,
        pillFs: 12,
        atcPv: 1.8,
        atcFs: 2.8
    };
    var DESIGN = {
        '9188898275512': {
            cardGap: 6,
            optsGap: 6,
            rowGap: 6,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 5,
            pillPh: 10,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9209172394168': {
            cardGap: 6,
            optsGap: 6,
            rowGap: 6,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 5,
            pillPh: 10,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9209196773560': {
            cardGap: 6,
            optsGap: 6,
            rowGap: 6,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 5,
            pillPh: 10,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9191504314552': {
            cardGap: 6,
            optsGap: 6,
            rowGap: 6,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 5,
            pillPh: 10,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '7358663131320': {
            cardGap: 10,
            optsGap: 10,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 12,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9233362518200': {
            cardGap: 12,
            optsGap: 12,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 12,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9233396072632': {
            cardGap: 12,
            optsGap: 12,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 12,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '10171904819384': {
            cardGap: 12,
            optsGap: 12,
            rowGap: 6,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 12,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9994601857208': {
            cardGap: 10,
            optsGap: 10,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 12,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '9994604347576': {
            cardGap: 10,
            optsGap: 10,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 12,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '10135358636216': {
            cardGap: 10,
            optsGap: 10,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 11,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '10135366238392': {
            cardGap: 10,
            optsGap: 10,
            rowGap: 8,
            thumb: 12,
            titleFs: 3.5,
            priceFs: 21,
            swatch: 4.8,
            pillPv: 6,
            pillPh: 11,
            pillFs: 12,
            atcPv: 1.8,
            atcFs: 2.8
        },
        '10353197908152': COLOURWAY_ROOMY,
        '10353198137528': COLOURWAY_ROOMY,
        '10362924728504': COLOURWAY_ROOMY,
        '10362954285240': COLOURWAY_ROOMY,
        '10361352978616': COLOURWAY_ROOMY,
        '10510775025848': COLOURWAY,
        '10509850083512': COLOURWAY
    };

    function igLog() {
        if (window.__IG_BB_DEBUG !== true) return;
        try {
            var args = ['[ig-buybox]'].concat(Array.prototype.slice.call(arguments));
            console.log.apply(console, args);
        } catch (e) {}
    }

    function igDesc(el) {
        if (!el) return 'null';
        try {
            // getAttribute, not .id: form elements with an <input name="id">
            // child (every Shopify product form) shadow the id property.
            var id = el.getAttribute && el.getAttribute('id') ? '#' + el.getAttribute('id') : '';
            var cls = (el.className || '').toString().trim().replace(/\s+/g, '.');
            cls = cls ? '.' + cls : '';
            return el.tagName.toLowerCase() + id + cls;
        } catch (e) {
            return String(el);
        }
    }

    function igDumpColour(root) {
        if (!root) return;
        igLog('colour dump:', {
            root: igDesc(root),
            labels: root.querySelectorAll('label').length,
            radios: root.querySelectorAll('input[type=radio]').length,
            anchors: root.querySelectorAll('a').length,
            imgs: root.querySelectorAll('img').length,
            html: (root.innerHTML || '').slice(0, 800)
        });
    }

    function igDumpOptionRoot(root, links) {
        igLog('option root:', {
            root: igDesc(root),
            linkCount: links ? links.length : 0,
            links: links ? Array.prototype.slice.call(links).map(function(a) {
                return {
                    el: igDesc(a),
                    text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40),
                    href: a.getAttribute('href')
                };
            }) : []
        });
    }

    igLog('loaded v' + IGV + ' — filter console by [ig-buybox]. Enable: window.__IG_BB_DEBUG = true');

    function stableVh() {
        var vh = window.innerHeight || 0;
        if (vh > vhLock) vhLock = vh;
        if (!vhMin || vh < vhMin) vhMin = vh;
        return vhLock || vh;
    }

    function targeted() {
        var pi = document.querySelector('product-images[data-product-id]');
        var id = pi ? pi.getAttribute('data-product-id') : '';
        if (!id && window.igMobileBuybox && window.igMobileBuybox.productId != null) {
            id = String(window.igMobileBuybox.productId);
        }
        if (!id) {
            DBG.stage = 'skipped';
            DBG.skipReason = 'no product id (no product-images[data-product-id] and no window.igMobileBuybox.productId)';
            igLog('skip: no product id');
            return false;
        }
        var sec = pi ? pi.closest('[id^="shopify-section-"]') : null;
        var form = null;
        if (!sec) {
            var forms = document.querySelectorAll('[id^="product-form-"]');
            for (var i = 0; i < forms.length; i++) {
                // getAttribute, not .id: Shopify product forms contain
                // <input name="id"> which shadows the form's id property.
                var fid = forms[i].getAttribute('id') || '';
                if (fid.indexOf('installment') !== -1) continue;
                form = forms[i];
                break;
            }
            sec = form ? form.closest('[id^="shopify-section-"]') : null;
        }
        if (!sec) {
            DBG.stage = 'skipped';
            DBG.skipReason = 'no #shopify-section-* wrapper found (no product-images element and no [id^="product-form-"] form outside installments)';
            igLog('skip: no shopify section for product', id);
            return false;
        }
        var suffix = sec.id.replace(/^shopify-section-/, '');
        SEC = '#' + sec.id;
        // Prefer the form we actually found: on some templates the form id
        // suffix does not equal the section id suffix.
        FORM = form ? '#' + form.getAttribute('id') : '#product-form-' + suffix;
        PID = id;
        DBG.stage = 'targeted';
        DBG.skipReason = '';
        igLog('targeted', { PID: id, SEC: SEC, FORM: FORM });
        return true;
    }

    function mergeRows() {
        return !!(PID && Object.prototype.hasOwnProperty.call(MERGE, PID));
    }

    function nudgeFor() {
        if (PID && Object.prototype.hasOwnProperty.call(NUDGE, PID)) return NUDGE[PID];
        return 0;
    }

    function designFor() {
        if (PID && Object.prototype.hasOwnProperty.call(DESIGN, PID)) return DESIGN[PID];
        return COLOURWAY;
    }

    function readFs(el, fallback) {
        try {
            if (!el) return fallback;
            var fs = parseFloat(window.getComputedStyle(el).fontSize);
            return isFinite(fs) && fs > 0 ? fs : fallback;
        } catch (e) {
            return fallback;
        }
    }

    function scaleDesign(d, f) {
        function s(v, min) {
            var n = v * f;
            return n < min ? min : n;
        }
        return {
            cardGap: s(d.cardGap, 3),
            optsGap: s(d.optsGap, 3),
            rowGap: s(d.rowGap, 4),
            thumb: s(d.thumb, 11),
            titleFs: s(d.titleFs, 0),
            priceFs: s(d.priceFs, 12),
            swatch: s(d.swatch, 1),
            pillPv: s(d.pillPv, 3),
            pillPh: s(d.pillPh, 8),
            pillFs: s(d.pillFs, 11),
            atcPv: s(d.atcPv, 1.1),
            atcFs: s(d.atcFs, 1.2)
        };
    }

    function ourNode(el) {
        try {
            if (!el) return true;
            if (el.id === 'ig-buybox' || el.id === 'ig-zoom-overlay') return true;
            if (el.closest('#ig-buybox') || el.closest('#ig-zoom-overlay')) return true;
            if (el.closest(SEC)) return true;
        } catch (e) {}
        return false;
    }

    function shown(el) {
        try {
            var cs = window.getComputedStyle(el);
            if (cs.display === 'none' || cs.visibility === 'hidden') return null;
            if (parseFloat(cs.opacity || '1') <= 0.05) return null;
            var r = el.getBoundingClientRect();
            if (r.width <= 0 || r.height <= 0) return null;
            var vh = window.innerHeight || 0;
            if (r.bottom < 0 || r.top > vh) return null;
            return {
                r: r,
                cs: cs
            };
        } catch (e) {}
        return null;
    }

    function fixedBig(el) {
        var s = shown(el);
        if (!s) return false;
        if (s.cs.position !== 'fixed') return false;
        return (s.r.width * s.r.height) >= 15000;
    }

    function vendorHit(el) {
        if (fixedBig(el)) return true;
        try {
            var kids = el.children;
            var n = kids.length > 200 ? 200 : kids.length;
            for (var i = 0; i < n; i++) {
                var k = kids[i];
                if (fixedBig(k)) return true;
                var gk = k.children;
                var m = gk.length > 200 ? 200 : gk.length;
                for (var j = 0; j < m; j++) {
                    if (fixedBig(gk[j])) return true;
                }
            }
        } catch (e) {}
        return false;
    }

    function domOverlay() {
        var vw = window.innerWidth || 1;
        var vh = window.innerHeight || 1;
        var vpArea = vw * vh;
        var i, el, s;
        try {
            var vend = document.querySelectorAll(VENDOR_SEL);
            for (i = 0; i < vend.length; i++) {
                el = vend[i];
                if (ourNode(el)) continue;
                if (vendorHit(el)) {
                    DBG.awayCulprit = 'vendor: ' + igDesc(el);
                    return true;
                }
            }
        } catch (e) {}
        try {
            var gen = document.querySelectorAll(GENERIC_SEL);
            for (i = 0; i < gen.length; i++) {
                el = gen[i];
                if (ourNode(el)) continue;
                s = shown(el);
                if (!s) continue;
                if (s.cs.position !== 'fixed') continue;
                if (s.r.height < 150) continue;
                if (s.r.width < vw * 0.5) continue;
                var area = s.r.width * s.r.height;
                var hasField = false;
                try {
                    hasField = !!el.querySelector('input, textarea, form');
                } catch (e2) {
                    hasField = false;
                }
                if (area < vpArea * 0.18 && !hasField) continue;
                DBG.awayCulprit = 'overlay: ' + igDesc(el) + ' (' + Math.round(s.r.width) + 'x' + Math.round(s.r.height) + ')';
                return true;
            }
        } catch (e) {}
        DBG.awayCulprit = '';
        return false;
    }

    function popupOpen() {
        if (klOpen) {
            if (klOpenAt && (Date.now() - klOpenAt) > 60000) {
                klOpen = false;
            } else {
                return true;
            }
        }
        return domOverlay();
    }

    function applyAway(state) {
        try {
            var b = document.getElementById('ig-buybox');
            if (!b) return;
            if (state !== b.classList.contains('ig-bb-away')) {
                igLog(state ? 'hidden (ig-bb-away): ' + (DBG.awayCulprit || 'klaviyo form open') : 'shown again (ig-bb-away removed)');
            }
            if (state) b.classList.add('ig-bb-away');
            else b.classList.remove('ig-bb-away');
        } catch (e) {}
    }
    window.addEventListener('klaviyoForms', function(e) {
        var t = '';
        try {
            t = (e && e.detail && e.detail.type) || '';
        } catch (err) {
            t = '';
        }
        if (t === 'open') {
            klOpen = true;
            klOpenAt = Date.now();
            applyAway(true);
        } else if (t === 'close' || t === 'redirectedToUrl') {
            klOpen = false;
            applyAway(domOverlay());
        }
    });

    function watchBody() {
        try {
            if (!document.body || window.__igBodyWatch) return;
            window.__igBodyWatch = 1;
            new MutationObserver(function() {
                applyAway(popupOpen());
            }).observe(document.body, {
                childList: true
            });
        } catch (e) {}
    }
    if (document.body) watchBody();
    else document.addEventListener('DOMContentLoaded', watchBody);
    var tries = 0;
    var timer = setInterval(function() {
        tries++;
        DBG.tries = tries;
        if (tries > 200) {
            clearInterval(timer);
            DBG.stage = 'gave-up';
            igLog('gave up after 200 tries — buybox never built. Run window.igBuyboxDebug() for a report.');
            igBuyboxDebug();
            return;
        }
        if (document.getElementById('ig-buybox')) {
            clearInterval(timer);
            return;
        }
        if (!targeted()) return;
        var form = document.querySelector(FORM);
        if (!form && SEC) {
            var secEl = document.querySelector(SEC);
            form = secEl ? secEl.querySelector('[id^="product-form-"]') : null;
        }
        var h1 = document.querySelector(SEC + ' h1');
        var atc = findAtc(form);
        DBG.waiting = {
            tries: tries,
            form: form ? igDesc(form) : 'MISSING (' + FORM + ')',
            h1: h1 ? igDesc(h1) : 'MISSING (' + SEC + ' h1)',
            atc: atc ? igDesc(atc) : 'MISSING (no ATC selector matched in form)'
        };
        if (!form || !h1 || !atc) {
            DBG.stage = 'waiting';
            if (tries === 1 || tries % 20 === 0 || tries > 195) {
                igLog('waiting for prerequisites', DBG.waiting);
            }
            return;
        }
        clearInterval(timer);
        DBG.stage = 'building';
        igLog('build start', {
            form: igDesc(form),
            h1: (h1.textContent || '').trim().slice(0, 60),
            atc: igDesc(atc),
            atcLabel: readBtnLabel(atc)
        });
        try {
            build(form, h1, atc);
            DBG.stage = 'built';
        } catch (e) {
            DBG.stage = 'build-error';
            DBG.buildError = (e && (e.stack || e.message)) || String(e);
            igLog('build error', e);
        }
        // If the box built but still isn't visible shortly after, print the
        // diagnostic automatically so the console explains why.
        setTimeout(function() {
            var b = document.getElementById('ig-buybox');
            if (!b || !isVisible(b)) igBuyboxDebug();
        }, 2500);
    }, 150);

    // On-demand diagnostic. Run window.igBuyboxDebug() in the console on any
    // PDP where the box is missing — it reports which gate stopped it.
    function igBuyboxDebug() {
        var report = {};
        try {
            var box = document.getElementById('ig-buybox');
            var boxCs = box ? window.getComputedStyle(box) : null;
            var mobile = false;
            try { mobile = window.matchMedia('(max-width: 749px)').matches; } catch (e) {}
            report = {
                stage: DBG.stage,
                skipReason: DBG.skipReason || undefined,
                buildError: DBG.buildError || undefined,
                waiting: DBG.waiting,
                productId: (window.igMobileBuybox && window.igMobileBuybox.productId) || null,
                PID: PID, SEC: SEC, FORM: FORM,
                viewport: window.innerWidth + 'x' + window.innerHeight,
                isMobileWidth: mobile,
                cssLinkPresent: !!document.querySelector('link[href*="component-mobile-buybox"]'),
                bodyHasIgBbOn: document.body ? document.body.classList.contains('ig-bb-on') : null,
                box: !box ? 'NOT IN DOM' : {
                    display: boxCs.display,
                    opacity: boxCs.opacity,
                    visibility: boxCs.visibility,
                    away: box.classList.contains('ig-bb-away'),
                    awayCulprit: DBG.awayCulprit || undefined,
                    rect: (function() { var r = box.getBoundingClientRect(); return Math.round(r.width) + 'x' + Math.round(r.height) + ' @y=' + Math.round(r.top); })()
                },
                dom: {
                    productImagesEl: !!document.querySelector('product-images[data-product-id]'),
                    productForms: Array.prototype.map.call(document.querySelectorAll('[id^="product-form-"]'), function(f) { return f.getAttribute('id'); }),
                    sectionH1: SEC ? !!document.querySelector(SEC + ' h1') : null,
                    atcInForm: (function() { var f = FORM && document.querySelector(FORM); return f ? igDesc(findAtc(f)) : null; })()
                }
            };
        } catch (e) {
            report.error = String(e);
        }
        try { console.log('[ig-buybox] DEBUG REPORT', report); } catch (e2) {}
        // Plain-language verdict for the most common causes.
        try {
            var verdict = '';
            if (report.stage === 'built' && report.box && report.box !== 'NOT IN DOM') {
                if (!report.isMobileWidth) verdict = 'Box is built but the viewport is ' + report.viewport + ' — CSS only shows it at max-width 749px. Test in a mobile viewport.';
                else if (report.box.away) verdict = 'Box is built but hidden by ig-bb-away. Culprit: ' + (report.box.awayCulprit || 'unknown overlay');
                else if (report.box.display === 'none') verdict = 'Box is in the DOM but display:none — the mobile CSS block did not apply. Check the CSS file loaded (cssLinkPresent).';
                else verdict = 'Box appears healthy. If you cannot see it, check z-index/overlays.';
            } else if (report.stage === 'waiting' || report.stage === 'gave-up') {
                verdict = 'Never built — still missing: ' + JSON.stringify(report.waiting);
            } else if (report.stage === 'skipped') {
                verdict = 'Skipped: ' + report.skipReason;
            } else if (report.stage === 'build-error') {
                verdict = 'build() threw: ' + report.buildError;
            }
            if (verdict) console.log('[ig-buybox] VERDICT:', verdict);
        } catch (e3) {}
        return report;
    }
    window.igBuyboxDebug = igBuyboxDebug;

    function isVisible(el) {
        try {
            if (!el) return false;
            var cs = window.getComputedStyle(el);
            if (cs.display === 'none' || cs.visibility === 'hidden') return false;
            if (parseFloat(cs.opacity || '1') <= 0.05) return false;
            var r = el.getBoundingClientRect();
            return r.width > 0 && r.height > 0;
        } catch (e) {}
        return false;
    }

    function readBtnLabel(el) {
        if (!el) return '';
        var best = '';
        var fallback = '';
        function consider(s) {
            s = (s || '').replace(/\s+/g, ' ').trim();
            if (!s || s === '.') return;
            var low = s.toLowerCase();
            if (low === 'out of stock' || low === 'sold out' || low === 'unavailable') {
                if (!fallback) fallback = s;
                return;
            }
            if (s.length > best.length) best = s;
        }
        consider(el.getAttribute('aria-label'));
        consider(el.getAttribute('value'));
        consider(el.innerText || el.textContent);
        try {
            var nodes = el.querySelectorAll('span, div, p, label');
            for (var i = 0; i < nodes.length; i++) {
                consider(nodes[i].innerText || nodes[i].textContent);
            }
        } catch (e) {}
        return best || fallback;
    }

    // Whether the resolved ATC target is Klaviyo's back-in-stock trigger
    // ("Notify Me When Available") rather than a real add-to-cart button.
    function isBisTarget(el) {
        if (!el) return false;
        try {
            if (el.closest('#klaviyo-bis-button-container')) return true;
            return el.classList.contains('klaviyo-bis-trigger');
        } catch (e) {}
        return false;
    }

    function findAtc(form) {
        if (!form) return null;
        // Klaviyo injects its real, clickable Notify Me button into
        // #klaviyo-bis-button-container (an ID, and possibly outside the form
        // element). The theme's own .klaviyo-bis-trigger anchor is only
        // Klaviyo's placement anchor — usually hidden and inert, so clicking
        // it does nothing. Prefer the injected button.
        var sels = [
            '#klaviyo-bis-button-container button',
            '#klaviyo-bis-button-container a',
            '.klaviyo-bis-button-container button',
            '.klaviyo-bis-trigger',
            '#add-to-cart-btn',
            '.product-atc-btn',
            'button[type="submit"][name="add"]',
            '[data-product-atc]'
        ];
        var i, el, visible = null, any = null;
        for (i = 0; i < sels.length; i++) {
            el = form.querySelector(sels[i]);
            // Klaviyo can mount its container outside the form — widen the
            // search to the product section for those selectors only.
            if (!el && sels[i].indexOf('klaviyo') !== -1 && SEC) {
                var secEl = document.querySelector(SEC);
                el = secEl ? secEl.querySelector(sels[i]) : null;
            }
            if (!el) continue;
            if (!any) any = el;
            if (isVisible(el)) {
                visible = el;
                break;
            }
        }
        return visible || any;
    }

    // Locked visitor on a gated product page (preorder-access-gate.liquid
    // renders gateActive: true only there). The buy box CTA is a clone, so the
    // gate's .restock-rocket-preorder-button CSS never reaches it. Deliberately
    // does NOT wait for Stoq to add that class: Stoq converts late, and until
    // then the clone was live and could add the gated product.
    function isPreorderPaused() {
        var cfg = window.preorderGateConfig;
        if (!cfg || !(cfg.gateActive || cfg.vipActive)) return false;
        return !document.documentElement.classList.contains('preorder-access-unlocked');
    }

    function preorderPausedLabel() {
        var cfg = window.preorderGateConfig;
        return (cfg && cfg.pausedLabel) || 'Preorder Coming Soon';
    }

    // Applies/clears the paused state on the clone and returns whether it is
    // paused, so callers skip the native-label mirror (which would overwrite
    // the paused label). Never sets `disabled` - theme JS reads that as sold
    // out. Paused colours live in preorder-access-gate.liquid.
    function applyCtaGate(cta) {
        var paused = isPreorderPaused();
        cta.classList.toggle('ig-bb-atc--preorder-paused', paused);
        if (paused) {
            var t = preorderPausedLabel();
            if (cta.textContent !== t) cta.textContent = t;
            cta.setAttribute('aria-disabled', 'true');
        } else {
            cta.removeAttribute('aria-disabled');
        }
        return paused;
    }

    function isColorContainer(el) {
        if (!el) return false;
        if (el.classList && el.classList.contains('color-selection__options')) return true;
        try {
            if (el.matches && el.matches('fieldset.color-selection')) return true;
            if (el.closest && el.closest('fieldset.color-selection')) return true;
        } catch (e) {}
        return false;
    }

    // Variant pickers on the default main-product template live OUTSIDE the
    // form element (inside <variant-radios>, associated via form="..."), so
    // scoped lookups must fall back from the form to the whole section.
    function scopeEls(form) {
        var out = [];
        if (form) out.push(form);
        var sec = SEC ? document.querySelector(SEC) : null;
        if (sec && sec !== form) out.push(sec);
        return out;
    }

    function colourRoot(form, quiet) {
        var scopes = scopeEls(form);
        var byClass = null, byFieldset = null, dawn = null;
        for (var i = 0; i < scopes.length && !byClass && !byFieldset && !dawn; i++) {
            byClass = scopes[i].querySelector('.color-selection__options');
            byFieldset = scopes[i].querySelector('fieldset.color-selection');
            // Dawn main-product: swatch radios + labels sit in this wrapper.
            var fs = scopes[i].querySelector('fieldset.product-form__input--color');
            if (fs) dawn = fs.querySelector('.product-form__color-swatches') || fs;
        }
        var root = byClass || byFieldset || dawn;
        if (!quiet) {
            igLog('colourRoot', {
                found: !!root,
                root: root ? igDesc(root) : null,
                byClass: byClass ? igDesc(byClass) : null,
                byFieldset: byFieldset ? igDesc(byFieldset) : null,
                dawn: dawn ? igDesc(dawn) : null
            });
        }
        return root;
    }

    function optionRoots(form, quiet) {
        var seen = [];
        var out = [];
        function add(n, src) {
            if (!n || seen.indexOf(n) >= 0) return;
            seen.push(n);
            out.push(n);
            if (!quiet) igLog('optionRoots add', src, igDesc(n));
        }
        if (!form) return out;
        var allOpts = form.querySelectorAll('[class*="__options"]');
        if (!quiet) igLog('optionRoots scan __options', allOpts.length);
        allOpts.forEach(function(c) {
            if (isColorContainer(c)) {
                if (!quiet) igLog('optionRoots skip color container', igDesc(c));
                return;
            }
            if (mergeRows() && isCollabContainer(c)) {
                if (!quiet) igLog('optionRoots skip collaboration (merged into colour)', igDesc(c));
                return;
            }
            // Nested containers (e.g. .model-size__options wrapping
            // .size-selection__options) would duplicate the row: the wrapper
            // and the inner container both match, and optionLinks() on the
            // wrapper falls through to the inner links. Keep the innermost.
            if (c.querySelector('[class*="__options"]')) {
                if (!quiet) igLog('optionRoots skip wrapper (has nested __options)', igDesc(c));
                return;
            }
            add(c, '__options');
        });
        form.querySelectorAll('fieldset.size-selection, fieldset.collaboration-selection, fieldset.number-of-seats').forEach(function(fs) {
            if (fs.querySelector('[class*="__options"]')) {
                if (!quiet) igLog('optionRoots skip fieldset (has __options child)', igDesc(fs));
                return;
            }
            if (fs.querySelector('a')) add(fs, 'fieldset-direct-links');
            else if (!quiet) igLog('optionRoots skip fieldset (no links)', igDesc(fs));
        });
        // Dawn main-product: non-colour options are radio+label pairs inside
        // dropdown fieldsets, which sit outside the form element.
        scopeEls(form).forEach(function(scope) {
            scope.querySelectorAll('fieldset.product-form__input--dropdown').forEach(function(fs) {
                var c = fs.querySelector('.product-form__dropdown-container') || fs;
                add(c, 'dawn-dropdown');
            });
        });
        if (!quiet) igLog('optionRoots total', out.length);
        return out;
    }

    function optionLinks(container, quiet) {
        if (!container) return [];
        var links = container.querySelectorAll(':scope > a');
        var src = ':scope > a';
        if (!links.length) {
            var inner = container.querySelector('[class*="__options"]');
            if (inner) {
                links = inner.querySelectorAll(':scope > a');
                src = 'inner __options > a';
            }
        }
        if (!links.length) {
            links = container.querySelectorAll('a[class*="__option"], a[class*="__options"]');
            src = 'a[class*=__option]';
        }
        if (!quiet) {
            if (!links.length) {
                igLog('optionLinks none found', igDesc(container), (container.innerHTML || '').slice(0, 400));
            } else {
                igLog('optionLinks', igDesc(container), src, links.length);
            }
        }
        return links;
    }

    // The radio input a label controls. Stroller markup nests the input
    // inside the label; Dawn (main-product) renders it as a sibling wired up
    // via for=/id, so check htmlFor and adjacent siblings too.
    function radioForLabel(lb) {
        if (!lb) return null;
        var inp = lb.querySelector('input[type=radio]');
        if (inp) return inp;
        try {
            if (lb.htmlFor) {
                var byId = document.getElementById(lb.htmlFor);
                if (byId && byId.type === 'radio') return byId;
            }
            var prev = lb.previousElementSibling;
            if (prev && prev.tagName === 'INPUT' && prev.type === 'radio') return prev;
        } catch (e) {}
        return null;
    }

    function optionLabels(container, quiet) {
        if (!container) return [];
        var labels = container.querySelectorAll(':scope > label');
        var src = ':scope > label';
        if (!labels.length) {
            var inner = container.querySelector('[class*="__options"]');
            if (inner) {
                labels = inner.querySelectorAll(':scope > label');
                src = 'inner __options > label';
            }
        }
        if (!labels.length) {
            labels = container.querySelectorAll('label');
            src = 'label';
        }
        var out = [];
        Array.prototype.forEach.call(labels, function(lb) {
            if (radioForLabel(lb)) out.push(lb);
        });
        if (!quiet) {
            if (!out.length) {
                igLog('optionLabels none found', igDesc(container), (container.innerHTML || '').slice(0, 400));
            } else {
                igLog('optionLabels', igDesc(container), src, out.length);
            }
        }
        return out;
    }

    function isSizeContainer(el) {
        try {
            if (!el) return false;
            if (el.closest && el.closest('.size-selection, fieldset.size-selection')) return true;
            if (el.classList && el.classList.contains('size-selection__options')) return true;
            if (el.className && el.className.toString().indexOf('size-selection') > -1) return true;
        } catch (e) {}
        return false;
    }

    function markUnavailable(el) {
        if (isSizeContainer(el)) return false;
        return optionUnavailable(el);
    }

    function optionUnavailable(el) {
        try {
            if (!el) return false;
            if (el.classList && el.classList.contains('color-selection__option--unavailable')) return true;
            if (el.classList && el.className && el.className.toString().indexOf('__option--unavailable') > -1) return true;
            if (el.closest && el.closest('.color-selection__option--unavailable')) return true;
            if (el.closest && el.closest('[class*="__option--unavailable"]')) return true;
            // Dawn main-product: crossed-out swatch wrapper.
            if (el.closest && el.closest('.Swatches_Box--unavailable')) return true;
            if (el.querySelector && el.querySelector('.color-selection__option--unavailable')) return true;
            if (el.querySelector && el.querySelector('[class*="__option--unavailable"]')) return true;
            var inp = el.matches && el.matches('input[type=radio]') ? el : (el.tagName === 'LABEL' ? radioForLabel(el) : (el.querySelector && el.querySelector('input[type=radio]')));
            if (inp && inp.disabled) return true;
        } catch (e) {}
        return false;
    }

    function appendLinkPill(row, a, extraClass) {
        var pill = document.createElement('a');
        pill.className = 'ig-bb-pill' + (extraClass ? ' ' + extraClass : '');
        if ((a.className || '').toString().indexOf('--active') > -1) pill.className += ' ig-bb-pill--on';
        var href = a.getAttribute('href');
        if (href) pill.href = href;
        if (markUnavailable(a)) pill.className += ' ig-bb-pill--unavailable';
        var im = a.querySelector('img');
        if (im) {
            pill.className += ' ig-bb-pill--img';
            var ni = document.createElement('img');
            ni.className = 'ig-bb-swatch';
            ni.src = im.currentSrc || im.src;
            ni.alt = '';
            pill.appendChild(ni);
        } else {
            pill.textContent = (a.textContent || '').replace(/\s+/g, ' ').trim();
        }
        row.appendChild(pill);
    }

    function appendLabelPill(row, lb, onPick) {
        var inp = radioForLabel(lb);
        if (!inp) return false;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ig-bb-pill';
        if (inp.checked) btn.className += ' ig-bb-pill--on';
        if (markUnavailable(lb)) btn.className += ' ig-bb-pill--unavailable';
        var im = lb.querySelector('img');
        if (im) {
            btn.className += ' ig-bb-pill--img';
            var ni = document.createElement('img');
            ni.className = 'ig-bb-swatch';
            ni.src = im.currentSrc || im.src;
            ni.alt = '';
            btn.appendChild(ni);
        } else {
            btn.textContent = (lb.textContent || '').replace(/\s+/g, ' ').trim();
        }
        btn.addEventListener('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            try {
                inp.click();
            } catch (e) {}
            row.querySelectorAll('.ig-bb-pill').forEach(function(x) {
                x.classList.remove('ig-bb-pill--on');
            });
            btn.classList.add('ig-bb-pill--on');
            if (onPick) onPick();
        });
        row.appendChild(btn);
        return true;
    }

    function syncLabelRow(container, row) {
        if (!container || !row) return;
        var labels = optionLabels(container, true);
        var pills = row.querySelectorAll('.ig-bb-pill');
        if (!labels.length || pills.length !== labels.length) return;
        pills.forEach(function(p, i) {
            var lb = labels[i];
            if (markUnavailable(lb)) p.classList.add('ig-bb-pill--unavailable');
            else p.classList.remove('ig-bb-pill--unavailable');
            var inp = radioForLabel(lb);
            if (inp && inp.checked) p.classList.add('ig-bb-pill--on');
            else p.classList.remove('ig-bb-pill--on');
        });
    }

    function colourSwatchContainers(form) {
        var out = [];
        var root = colourRoot(form, true);
        if (root) out.push(root);
        if (mergeRows()) {
            var collab = form.querySelector('.collaboration-selection__options');
            if (!collab) {
                var fs = form.querySelector('fieldset.collaboration-selection');
                if (fs) collab = fs.querySelector('[class*="__options"]') || fs;
            }
            if (collab && out.indexOf(collab) < 0) out.push(collab);
        }
        return out;
    }

    // Swatch image URL when the label paints it via CSS background-image
    // (Dawn main-product: label.product-form__color-swatch).
    function labelBgSwatch(lb) {
        try {
            var bg = (lb.style && lb.style.backgroundImage) || window.getComputedStyle(lb).backgroundImage || '';
            var m = bg.match(/url\(["']?(.+?)["']?\)/);
            return m ? m[1] : '';
        } catch (e) {}
        return '';
    }

    function appendColourLabelPill(row, lb, onPick) {
        var inp = radioForLabel(lb);
        if (!inp) return false;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ig-bb-pill ig-bb-pill--colour ig-bb-pill--img';
        if (inp.checked) btn.className += ' ig-bb-pill--on';
        if (markUnavailable(lb)) btn.className += ' ig-bb-pill--unavailable';
        var im = lb.querySelector('img');
        var bgUrl = im ? '' : labelBgSwatch(lb);
        if (im || bgUrl) {
            var ni = document.createElement('img');
            ni.className = 'ig-bb-swatch';
            ni.src = im ? (im.currentSrc || im.src) : bgUrl;
            ni.alt = '';
            btn.appendChild(ni);
        } else {
            btn.className = 'ig-bb-pill ig-bb-pill--colour';
            if (inp.checked) btn.className += ' ig-bb-pill--on';
            if (markUnavailable(lb)) btn.className += ' ig-bb-pill--unavailable';
            btn.textContent = (lb.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 14);
        }
        btn.addEventListener('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            try {
                inp.click();
            } catch (e) {}
            row.querySelectorAll('.ig-bb-pill--colour').forEach(function(x) {
                x.classList.remove('ig-bb-pill--on');
            });
            btn.classList.add('ig-bb-pill--on');
            if (onPick) onPick();
        });
        row.appendChild(btn);
        return true;
    }

    function syncColourRow(sources, row) {
        if (!row || !sources.length) return;
        var pills = row.querySelectorAll('.ig-bb-pill--colour');
        if (pills.length !== sources.length) return;
        pills.forEach(function(p, i) {
            var src = sources[i];
            var isOn = false;
            if (src.tagName === 'A') {
                isOn = (src.className || '').toString().indexOf('--active') > -1;
            } else {
                var inp = src.tagName === 'LABEL' ? radioForLabel(src) : src.querySelector('input[type=radio]');
                isOn = !!(inp && inp.checked);
            }
            if (markUnavailable(src)) p.classList.add('ig-bb-pill--unavailable');
            else p.classList.remove('ig-bb-pill--unavailable');
            if (isOn) p.classList.add('ig-bb-pill--on');
            else p.classList.remove('ig-bb-pill--on');
        });
    }

    function isCollabContainer(el) {
        try {
            return !!(el.closest('.collaboration-selection') || el.closest('fieldset.collaboration-selection'));
        } catch (e) {}
        return false;
    }

    function thumbSrcFrom(img) {
        // Lazysizes images (snippets/lazy-image.liquid) start life with a
        // 10px-wide placeholder src and keep the real URL in data-src as a
        // "..._{width}x{height}.jpg" template. If we copy src before the
        // swap the thumb renders the 10px placeholder, so build a proper
        // 240px URL from the template instead.
        var ds = img.getAttribute('data-src');
        if (ds && ds.indexOf('{width}') > -1) {
            return ds.replace('{width}x{height}', '240x');
        }
        return img.currentSrc || img.src;
    }

    function build(form, h1, atc) {
        var nativeTitleFs = readFs(h1, 15);
        var nativeAtcFs = readFs(atc, 15);

        function activeDesign() {
            var d = designFor();
            d.titleFs = nativeTitleFs;
            d.atcFs = nativeAtcFs;
            return d;
        }

        var box = document.createElement('div');
        box.id = 'ig-buybox';
        box.setAttribute('data-ig-v', IGV);
        var top = document.createElement('div');
        top.className = 'ig-bb-top';
        var thumb = null;
        var gal = document.querySelector(SEC + ' .stroller-product-images__media');
        if (!gal) {
            // Default main-product template gallery image. Slick injects its
            // nav arrows (<button class="slick-arrow"><img src="prev.png">)
            // inside the media wrapper before the real slides, so a plain
            // querySelector can pick up the arrow image - skip any <img>
            // inside a button/.slick-arrow.
            var galCands = document.querySelectorAll(SEC + ' .product__media-wrapper img, ' + SEC + ' .product__media img');
            for (var gi = 0; gi < galCands.length; gi++) {
                if (galCands[gi].closest('button, .slick-arrow')) continue;
                gal = galCands[gi];
                break;
            }
        }
        if (gal && gal.tagName === 'IMG') {
            thumb = document.createElement('img');
            thumb.className = 'ig-bb-thumb';
            thumb.src = thumbSrcFrom(gal);
            thumb.alt = '';
            top.appendChild(thumb);
        }
        var meta = document.createElement('div');
        meta.className = 'ig-bb-meta';
        var rating = document.createElement('div');
        rating.className = 'ig-bb-rating';
        var titleEl = document.createElement('div');
        titleEl.className = 'ig-bb-title';
        titleEl.textContent = (h1.textContent || '').trim();
        var priceEl = document.createElement('div');
        priceEl.className = 'ig-bb-price';

        // snippets/dynamic-price.liquid wrapper, once discount-display.js has
        // switched it to the sale price. Its hidden full-price span carries
        // the same price class as the sale span, so it must be checked first.
        function activeDiscountWrap() {
            return document.querySelector(SEC + ' .stroller-main-product__price .dynamic-price-wrapper.discount-active, ' +
                SEC + ' .product__mobile-header-price .dynamic-price-wrapper.discount-active');
        }

        function readPrice() {
            var dw = activeDiscountWrap();
            var dp = dw && dw.querySelector('.price-with-discount .price-discounted');
            if (dp) return (dp.textContent || '').replace(/\s+/g, ' ').trim();
            var p = document.querySelector(SEC + ' .stroller-main-product__price-amount');
            if (!p) {
                // Default main-product template: snippets/price.liquid renders
                // both .price__sale and .price__regular; take the sale price
                // when its block is visible, else the regular one.
                var wrap = document.querySelector(SEC + ' .product__mobile-header-price') ||
                    document.querySelector(SEC + ' .product__price');
                if (wrap) {
                    var sale = wrap.querySelector('.price__sale .price-item--sale');
                    var reg = wrap.querySelector('.price__regular .price-item--regular');
                    if (sale && isVisible(sale)) p = sale;
                    else if (reg && isVisible(reg)) p = reg;
                    else p = sale || reg || wrap;
                }
            }
            if (!p) return '';
            var clone = p.cloneNode(true);
            try {
                clone.querySelectorAll('s, del, strike, [class*="compare"], [class*="was"], [class*="old"], [class*="regular"], .visually-hidden, .sr-   only').forEach(function(n) {
                    n.remove();
                });
            } catch (e) {}
            var t = (clone.textContent || '').replace(/\s+/g, ' ').trim();
            var m = t.match(/[$€£¥]\s?[\d.,]+|[\d.,]+\s?(USD|CAD|AUD|EUR|GBP)/i);
            return m ? m[0].trim() : t;
        }

        // Plain price, or "$499.00 $399.20 (20% OFF)" with the full price
        // struck when a discount is live, matching the desktop price row.
        function applyPrice() {
            var price = readPrice();
            if (!price) return;
            var dw = activeDiscountWrap();
            var cmp = dw && dw.querySelector('.price-with-discount .price-compare');
            var off = dw && dw.querySelector('.price-with-discount .price-discounted-percentage');
            // PDP pill badge from snippets/dynamic-price.liquid ("20% OFF • Save $139")
            var pillOff = dw && dw.querySelector('.price-with-discount .price-discount-pill-row:not([hidden]) .price-discount-pill__off');
            var pillSave = dw && dw.querySelector('.price-with-discount .price-discount-pill__save:not([hidden])');
            var cmpText = cmp ? (cmp.textContent || '').replace(/\s+/g, ' ').trim() : '';
            var offText = off ? (off.textContent || '').replace(/\s+/g, ' ').trim() : '';
            var pillOffText = pillOff ? (pillOff.textContent || '').replace(/\s+/g, ' ').trim() : '';
            var pillSaveText = pillSave ? (pillSave.textContent || '').replace(/\s+/g, ' ').trim() : '';
            var key = cmpText + '|' + price + '|' + offText + '|' + pillOffText + '|' + pillSaveText;
            if (priceEl.getAttribute('data-igkey') === key) return;
            priceEl.setAttribute('data-igkey', key);
            if (!cmpText) {
                priceEl.textContent = price;
                return;
            }
            priceEl.innerHTML = '';
            var was = document.createElement('s');
            was.className = 'ig-bb-price__compare';
            was.textContent = cmpText;
            var now = document.createElement('span');
            now.className = 'ig-bb-price__sale';
            now.textContent = price;
            // Spaces between the parts give the line somewhere to wrap on
            // narrow screens instead of running off the box.
            priceEl.appendChild(was);
            priceEl.appendChild(document.createTextNode(' '));
            priceEl.appendChild(now);
            if (pillOffText) {
                var row = document.createElement('div');
                row.className = 'ig-bb-price__pill-row';
                var pill = document.createElement('span');
                pill.className = 'price-discount-pill';
                var icon = pillOff.closest('.price-discount-pill').querySelector('.price-discount-pill__icon');
                if (icon) pill.appendChild(icon.cloneNode(true));
                var pillText = document.createElement('span');
                pillText.className = 'price-discount-pill__text';
                var pillOffEl = document.createElement('span');
                pillOffEl.className = 'price-discount-pill__off';
                pillOffEl.textContent = pillOffText;
                pillText.appendChild(pillOffEl);
                if (pillSaveText) {
                    var pillSaveEl = document.createElement('span');
                    pillSaveEl.className = 'price-discount-pill__save';
                    pillSaveEl.textContent = pillSaveText;
                    pillText.appendChild(pillSaveEl);
                }
                pill.appendChild(pillText);
                row.appendChild(pill);
                priceEl.appendChild(row);
            } else if (offText) {
                var pct = document.createElement('span');
                pct.className = 'ig-bb-price__off';
                pct.textContent = offText;
                priceEl.appendChild(document.createTextNode(' '));
                priceEl.appendChild(pct);
            }
        }

        function readRating() {
            var a = document.querySelector('.bv_avgRating_component_container');
            var n = document.querySelector('.bv_numReviews_text');
            var s = a ? parseFloat((a.textContent || '').replace(/[^0-9.]/g, '')) : NaN;
            var c = n ? (n.textContent || '').replace(/\s+/g, ' ').trim() : '';
            if (!isFinite(s) || s <= 0) return null;
            return {
                s: s,
                c: c
            };
        }

        function applyRating() {
            var r = readRating();
            if (!r) return;
            var key = r.s + '|' + r.c;
            if (rating.getAttribute('data-igkey') === key) return;
            rating.setAttribute('data-igkey', key);
            var pct = Math.max(0, Math.min(100, (r.s / 5) * 100));
            rating.innerHTML = '';
            var st = document.createElement('span');
            st.className = 'ig-bb-stars';
            var fl = document.createElement('span');
            fl.className = 'ig-bb-stars-fill';
            fl.style.width = pct + '%';
            st.appendChild(fl);
            var sc = document.createElement('span');
            sc.className = 'ig-bb-score';
            sc.textContent = r.s.toFixed(1);
            rating.appendChild(st);
            rating.appendChild(sc);
            if (r.c) {
                var ct = document.createElement('span');
                ct.className = 'ig-bb-count';
                ct.textContent = r.c;
                rating.appendChild(ct);
            }
        }
        applyPrice();
        meta.appendChild(rating);
        meta.appendChild(titleEl);
        meta.appendChild(priceEl);
        top.appendChild(meta);
        box.appendChild(top);
        var opts = document.createElement('div');
        opts.className = 'ig-bb-opts';
        var seatRows = [];
        var seRows = [];
        var labelRows = [];
        var anchorRows = optionRoots(form);
        igLog('build options: anchorRows', anchorRows.length);
        anchorRows.forEach(function(c) {
            var links = optionLinks(c);
            var labels = links.length ? [] : optionLabels(c);
            igDumpOptionRoot(c, links);
            if (!links.length && labels.length) {
                igLog('build option row: using labels', igDesc(c), labels.length);
            }
            if (!links.length && !labels.length) return;
            var row = document.createElement('div');
            row.className = 'ig-bb-row';
            if (links.length) {
                links.forEach(function(a) {
                    appendLinkPill(row, a);
                });
            } else {
                labels.forEach(function(lb) {
                    appendLabelPill(row, lb, function() {
                        setTimeout(bump, 300);
                        setTimeout(bump, 900);
                    });
                });
                labelRows.push({
                    container: c,
                    row: row
                });
            }
            if (!row.children.length) return;
            if (isCollabContainer(c)) {
                row.className += ' ig-bb-row--se';
                seRows.push(row);
                igLog('build row: collaboration', row.children.length, 'pills');
            } else {
                row.className += ' ig-bb-row--seat';
                seatRows.push(row);
                igLog('build row: seat/size', row.children.length, 'pills', links.length ? 'links' : 'labels');
            }
        });
        var crow = null;
        var colourSources = [];
        var colourContainers = colourSwatchContainers(form);
        igLog('build colour containers', colourContainers.length, colourContainers.map(igDesc));
        if (colourContainers.length) {
            crow = document.createElement('div');
            crow.className = 'ig-bb-row ig-bb-row--colour';
            colourContainers.forEach(function(container) {
                var labels = optionLabels(container, true);
                var links = labels.length ? [] : optionLinks(container, true);
                igLog('build colour container', igDesc(container), 'labels:', labels.length, 'links:', links.length);
                if (links.length) {
                    links.forEach(function(a) {
                        appendLinkPill(crow, a, 'ig-bb-pill--colour');
                        colourSources.push(a);
                    });
                } else {
                    labels.forEach(function(lb) {
                        if (appendColourLabelPill(crow, lb, function() {
                            setTimeout(bump, 300);
                            setTimeout(bump, 900);
                        })) {
                            colourSources.push(lb);
                        }
                    });
                }
            });
            if (!crow.children.length) {
                igLog('build colour row empty — no swatches built');
                crow = null;
                colourSources = [];
            } else {
                igLog('build colour row', crow.children.length, 'swatches');
            }
        } else {
            igLog('build colour: no colour containers found in form', igDesc(form));
        }
        seatRows.forEach(function(r) {
            opts.appendChild(r);
        });
        if (crow) opts.appendChild(crow);
        seRows.forEach(function(r) {
            opts.appendChild(r);
        });
        if (opts.children.length) box.appendChild(opts);
        igLog('build summary', {
            seatRows: seatRows.length,
            seRows: seRows.length,
            labelRows: labelRows.length,
            colourSwatches: crow ? crow.children.length : 0,
            optsChildren: opts.children.length,
            mergeRows: mergeRows(),
            atcLabel: readBtnLabel(atc)
        });
        var cta = document.createElement('button');
        cta.type = 'button';
        cta.className = 'ig-bb-atc';

        // Label and shape both come off one resolved target so they can never
        // disagree about whether this is a waiting list button.
        function syncCta() {
            var target = findAtc(form) || atc;
            var paused = isPreorderPaused();
            cta.classList.toggle('ig-bb-atc--preorder-paused', paused);
            if (paused) {
                var pausedText = preorderPausedLabel();
                if (cta.textContent !== pausedText) cta.textContent = pausedText;
                cta.setAttribute('aria-disabled', 'true');
                cta.classList.remove('ig-bb-atc--bis');
                cta.classList.remove('ig-bb-atc--oos');
                cta.style.display = '';
                return;
            }
            cta.removeAttribute('aria-disabled');
            var label = readBtnLabel(target);
            // Stoq preorder (unlocked): append the live PDP price so the CTA
            // reads "Preorder · $2,599.00". Recomputed from the native button
            // every sync, so it never compounds on its own output.
            var isPreorderTarget = false;
            try {
                isPreorderTarget = !!(target && target.classList && target.classList.contains('restock-rocket-preorder-button'));
            } catch (e) {}
            if (isPreorderTarget) {
                var preorderPrice = readPrice();
                if (label && preorderPrice) label = label + ' \u00B7 ' + preorderPrice;
            }
            if (label && cta.textContent !== label) cta.textContent = label;
            var isBis = isBisTarget(target);
            cta.classList.toggle('ig-bb-atc--bis', isBis);
            // The theme hides its own .product-form__submit BIS anchor with
            // klaviyo-bis-trigger--theme-hidden when the variant is in stock.
            // The buy box CTA is a clone, so mirror that hide or "Notify Me"
            // stays up after the form has already swapped back to Add to Cart.
            var themeBisHidden = !!(isBis && form.querySelector(
                '.product-form__submit.klaviyo-bis-trigger--theme-hidden'
            ));
            cta.style.display = themeBisHidden ? 'none' : '';
            // Mirror the real button's disabled state (e.g. Stoq preorder cap
            // flips it to disabled "Out of Stock" in place), not just its
            // label. isMainAtcOutOfStock ignores the transient `loading`
            // disable while an add is in flight, so the CTA doesn't flash grey.
            var targetDisabled = !!(target && (
                typeof window.isMainAtcOutOfStock === 'function'
                    ? window.isMainAtcOutOfStock(target)
                    : (target.disabled && !target.classList.contains('loading'))
            ));
            if (targetDisabled) cta.setAttribute('aria-disabled', 'true');
            var low = (label || '').toLowerCase();
            cta.classList.toggle(
                'ig-bb-atc--oos',
                targetDisabled || low === 'out of stock' || low === 'sold out' || low === 'unavailable'
            );
        }

        syncCta();
        if (!cta.textContent) cta.textContent = 'Add to Cart';

        // Theme discount tab "Sale ends text" ("Black Friday sale ends on
        // Nov 27"). discount-display.js puts it on the active price wrapper.
        var endsEl = document.createElement('div');
        endsEl.className = 'ig-bb-ends';

        function syncEnds() {
            var dw = activeDiscountWrap();
            var text = dw ? (dw.getAttribute('data-ends-text') || '').replace(/\s+/g, ' ').trim() : '';
            if (endsEl.getAttribute('data-igkey') === text) return;
            endsEl.setAttribute('data-igkey', text);
            endsEl.replaceChildren();
            if (text) {
                endsEl.innerHTML = '<svg class="ig-bb-ends__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
                    '<circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>' +
                    '<path d="M8 4.75V8l2.25 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                var endsText = document.createElement('span');
                endsText.textContent = text;
                endsEl.appendChild(endsText);
            }
            endsEl.classList.toggle('ig-bb-ends--on', !!text);
        }

        syncEnds();
        box.appendChild(endsEl);

        // Gated-PDP metafield upsell (the pro-package--gate-upsell tile,
        // checkbox #add-e-wheels-package): while it is checked, mirror the
        // upsell name + price in a strip just above the CTA so the shopper
        // sees what the ATC will add. The tile class only renders on gated
        // PDPs, so this is a no-op everywhere else.
        var upsellEl = document.createElement('div');
        upsellEl.className = 'ig-bb-upsell';

        // Shown in the locked/paused state too — the tile itself is visible
        // to locked visitors, so its checked state should mirror regardless.
        function syncUpsell() {
            var on = false;
            var tile = document.querySelector('pro-package.pro-package--gate-upsell');
            if (tile) {
                var input = tile.querySelector('.pro-package__checkbox');
                if (input && input.checked && !input.disabled) {
                    var nameEl = tile.querySelector('.pro-package__title');
                    var upPriceEl = tile.querySelector('.pro-package__price');
                    var name = nameEl ? (nameEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
                    var upPriceHtml = upPriceEl ? (upPriceEl.innerHTML || '').trim() : '';
                    if (name || upPriceHtml) {
                        var prevNameEl = upsellEl.querySelector('.ig-bb-upsell__name');
                        var prevPriceEl = upsellEl.querySelector('.ig-bb-upsell__price');
                        var prevName = prevNameEl ? prevNameEl.textContent : '';
                        var prevPriceHtml = prevPriceEl ? prevPriceEl.innerHTML : '';
                        if (prevName !== name || prevPriceHtml !== upPriceHtml) {
                            upsellEl.replaceChildren();
                            if (name) {
                                var nameSpan = document.createElement('span');
                                nameSpan.className = 'ig-bb-upsell__name';
                                nameSpan.textContent = name;
                                upsellEl.appendChild(nameSpan);
                                upsellEl.appendChild(document.createTextNode(' '));
                            }
                            if (upPriceHtml) {
                                var priceSpan = document.createElement('span');
                                priceSpan.className = 'ig-bb-upsell__price';
                                priceSpan.innerHTML = upPriceHtml;
                                upsellEl.appendChild(priceSpan);
                            }
                        }
                        on = true;
                    }
                }
            }
            upsellEl.classList.toggle('ig-bb-upsell--on', on);
        }

        syncUpsell();
        // The checkbox change bubbles to document (covers taps and the
        // ?ewheels cookie preselect, which dispatches a bubbling change).
        document.addEventListener('change', function (ev) {
            try {
                if (ev.target && ev.target.closest && ev.target.closest('pro-package.pro-package--gate-upsell')) {
                    syncUpsell();
                    setTimeout(bump, 50);
                }
            } catch (e) {}
        });
        box.appendChild(upsellEl);

        cta.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            // Re-checked at click time so the gate holds even between the
            // 700ms sync ticks.
            if (applyCtaGate(cta)) {
                igLog('preorder paused, click dropped');
                return;
            }
            try {
                var clickTarget = findAtc(form) || atc;
                clickTarget.click();
            } catch (e) {}
        });
        box.appendChild(cta);

        function applyDesign(d) {
            var s = box.style;
            s.setProperty('--ig-card-gap', d.cardGap + 'px');
            s.setProperty('--ig-opts-gap', d.optsGap + 'px');
            s.setProperty('--ig-row-gap', d.rowGap + 'px');
            s.setProperty('--ig-thumb', d.thumb + 'dvh');
            s.setProperty('--ig-title-fs', d.titleFs + 'px');
            s.setProperty('--ig-price-fs', d.priceFs + 'px');
            s.setProperty('--ig-pill-pv', d.pillPv + 'px');
            s.setProperty('--ig-pill-ph', d.pillPh + 'px');
            s.setProperty('--ig-pill-fs', d.pillFs + 'px');
            s.setProperty('--ig-atc-pv', d.atcPv + 'dvh');
            s.setProperty('--ig-atc-fs', d.atcFs + 'px');
        }
        applyDesign(activeDesign());
        document.body.appendChild(box);
        document.body.classList.add('ig-bb-on');
        try {
            var secEl = document.querySelector(SEC);
            if (secEl) secEl.setAttribute('data-ig-bb-section', '');
            form.setAttribute('data-ig-bb-form', '');
        } catch (e) {}
        if (klOpen) box.classList.add('ig-bb-away');
        applyRating();
        try {
            form.addEventListener('change', function() {
                setTimeout(bump, 300);
                setTimeout(bump, 900);
            });
        } catch (e) {}
        var anchorEl = null;
        var lastKey = '';
        var measuring = false;

        function anchorBottomDoc() {
            if (!anchorEl) anchorEl = document.querySelector(SEC + ' ' + ANCHOR);
            if (!anchorEl) return 0;
            var r = anchorEl.getBoundingClientRect();
            if (!r || r.height <= 0) return 0;
            var y = r.bottom;
            return Math.round(y + (window.pageYOffset || document.documentElement.scrollTop || 0));
        }

        function syncFit() {
            try {
                if (measuring) return;
                var vh = stableVh();
                var ab = anchorBottomDoc();
                var key = ab + ':' + vh + ':' + window.innerWidth + ':' + (PID || '');
                if (key === lastKey) return;
                measuring = true;
                lastKey = key;
                var base = activeDesign();
                var avail = (ab > 0 && vh > 0) ? (vh - ab + nudgeFor()) : 0;
                var nat = 0;
                var i;
                for (i = 0; i < SCALES.length; i++) {
                    applyDesign(scaleDesign(base, SCALES[i]));
                    box.style.minHeight = '';
                    nat = Math.ceil(box.getBoundingClientRect().height);
                    if (avail <= 0 || nat <= avail) break;
                }
                var want = avail > 0 ? avail : nat;
                if (want < nat) want = nat;
                var cap = Math.round(vh * CAP);
                if (cap > 0 && want > cap) want = Math.max(nat, cap);
                box.style.minHeight = want + 'px';
                measuring = false;
            } catch (e) {
                measuring = false;
            }
        }
        var lastH = 0;
        var chromeHidden = false;
        var CHROME_THRESH = 16;

        function bottomBarHidden() {
            var max = stableVh();
            var cur = window.innerHeight || 0;
            if (window.visualViewport && window.visualViewport.height) {
                cur = Math.max(cur, window.visualViewport.height);
            }
            return max - vhMin >= CHROME_THRESH && cur >= max - CHROME_THRESH;
        }

        function syncChrome() {
            try {
                var hidden = bottomBarHidden();
                if (hidden === chromeHidden) return;
                chromeHidden = hidden;
                if (hidden) box.classList.add('ig-bb-nobar');
                else box.classList.remove('ig-bb-nobar');
            } catch (e) {}
        }

        function syncH() {
            try {
                syncFit();
                syncChrome();
                var h = Math.ceil(box.getBoundingClientRect().height);
                if (h > 0 && h !== lastH) {
                    lastH = h;
                    document.body.style.setProperty('--ig-bb-h', h + 'px');
                }
            } catch (e) {}
        }

        function bump() {
            lastKey = '';
            anchorEl = null;
            syncH();
        }
        syncH();
        if (window.ResizeObserver) {
            try {
                new ResizeObserver(syncH).observe(box);
            } catch (e) {}
        }
        window.addEventListener('resize', syncH);
        window.addEventListener('scroll', syncChrome, {
            passive: true
        });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', syncChrome);
        }
        window.addEventListener('orientationchange', function() {
            vhLock = 0;
            vhMin = 0;
            chromeHidden = false;
            box.classList.remove('ig-bb-nobar');
            setTimeout(function() {
                vhLock = 0;
                vhMin = 0;
                bump();
            }, 250);
        });
        window.addEventListener('load', bump);
        setTimeout(bump, 400);
        setTimeout(bump, 1200);
        setTimeout(bump, 2500);
        setInterval(function() {
            try {
                var away = popupOpen();
                if (away !== box.classList.contains('ig-bb-away')) {
                    if (away) box.classList.add('ig-bb-away');
                    else box.classList.remove('ig-bb-away');
                }
                if (away) return;
                syncH();
                applyRating();
                applyPrice();
                var g = document.querySelector(SEC + ' .stroller-product-images__media');
                if (g && g.tagName === 'IMG' && thumb) {
                    var s = thumbSrcFrom(g);
                    if (s && thumb.src !== s) thumb.src = s;
                }
                // Full re-sync (label + --bis/--oos classes + disabled
                // mirror), not just the label: the button can flip to a
                // disabled "Out of Stock" long after build (e.g. Stoq cap).
                syncCta();
                syncEnds();
                syncUpsell();
                if (crow && colourSources.length) {
                    syncColourRow(colourSources, crow);
                }
                labelRows.forEach(function(entry) {
                    syncLabelRow(entry.container, entry.row);
                });
            } catch (e) {}
        }, 700);
    }
})();
(async () => {
    const {
        onElement
    } = await window.igImport('observe-dom@1');
    onElement('[id^="shopify-section-"] .stroller-product-images__slider-main', (slider) => {
        if (slider.dataset.igCounterInit) return;
        slider.dataset.igCounterInit = '1';
        var tries = 0;
        var timer = setInterval(function() {
            tries++;
            var list = slider.querySelector('.slick-list');
            var wrapper = slider.closest('.stroller-product-images');
            var dotsList = wrapper ? wrapper.querySelector('.stroller-product-images__dots') : null;
            if (!list || !dotsList) {
                if (tries > 60) clearInterval(timer);
                return;
            }
            clearInterval(timer);
            if (slider.querySelector('.ig-gallery-counter')) return;
            var pill = document.createElement('div');
            pill.className = 'ig-gallery-counter';
            slider.appendChild(pill);
            var updateCounter = function() {
                var items = dotsList.querySelectorAll('.stroller-product-images__dot');
                if (!items.length) {
                    pill.style.display = 'none';
                    return;
                }
                var activeIndex = 0;
                items.forEach(function(btn, i) {
                    if (btn.classList.contains('stroller-product-images__dot--active')) activeIndex = i;
                });
                pill.textContent = (activeIndex + 1) + ' / ' + items.length;
            };
            updateCounter();
            var observer = new MutationObserver(updateCounter);
            observer.observe(dotsList, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true,
                childList: true
            });
        }, 150);
    });
})();
(function() {
    if (document.getElementById('ig-zoom-overlay')) return;
    const overlay = document.createElement('div');
    overlay.id = 'ig-zoom-overlay';
    overlay.innerHTML = '<div class="ig-zoom-viewport"><div class="ig-zoom-track"></div></div><button type="button" class="ig-zoom-close" aria-label="Close">×</button><button type="button" class="ig-zoom-arrow ig-zoom-arrow--prev" aria-label="Previous image">‹</button><button type="button" class="ig-zoom-arrow ig-zoom-arrow--next" aria-label="Next image">›</button><div class="ig-zoom-counter"></div>';
    document.body.appendChild(overlay);
    const track = overlay.querySelector('.ig-zoom-track');
    const counter = overlay.querySelector('.ig-zoom-counter');
    const closeBtn = overlay.querySelector('.ig-zoom-close');
    const prevBtn = overlay.querySelector('.ig-zoom-arrow--prev');
    const nextBtn = overlay.querySelector('.ig-zoom-arrow--next');
    let images = [];
    let current = 0;
    let dragStartX = null;
    let dragBase = 0;
    let dragging = false;

    function render(withTransition) {
        track.style.transition = withTransition ? 'transform 0.25s ease' : 'none';
        track.style.transform = 'translateX(' + (-current * 100) + '%)';
        counter.textContent = (current + 1) + ' / ' + images.length;
    }

    function openZoom(srcs, startIndex) {
        images = srcs;
        current = startIndex;
        track.innerHTML = '';
        images.forEach(function(src) {
            const slide = document.createElement('div');
            slide.className = 'ig-zoom-slide';
            const img = document.createElement('img');
            img.src = src;
            slide.appendChild(img);
            track.appendChild(slide);
        });
        render(false);
        overlay.classList.add('ig-open');
        document.body.style.overflow = 'hidden';
    }

    function closeZoom() {
        overlay.classList.remove('ig-open');
        document.body.style.overflow = '';
    }

    function goTo(index) {
        const n = images.length;
        if (!n) return;
        current = ((index % n) + n) % n;
        render(true);
    }
    closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        closeZoom();
    });
    prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        goTo(current - 1);
    });
    nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        goTo(current + 1);
    });
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay || e.target.closest('.ig-zoom-viewport')) closeZoom();
    });
    document.addEventListener('keydown', function(e) {
        if (!overlay.classList.contains('ig-open')) return;
        if (e.key === 'Escape') closeZoom();
        else if (e.key === 'ArrowLeft') goTo(current - 1);
        else if (e.key === 'ArrowRight') goTo(current + 1);
    });
    track.addEventListener('touchstart', function(e) {
        if (!images.length) return;
        dragging = true;
        dragStartX = e.touches[0].clientX;
        dragBase = -current * track.parentElement.clientWidth;
        track.style.transition = 'none';
    }, {
        passive: true
    });
    track.addEventListener('touchmove', function(e) {
        if (!dragging) return;
        const delta = e.touches[0].clientX - dragStartX;
        track.style.transform = 'translateX(' + (dragBase + delta) + 'px)';
    }, {
        passive: true
    });
    track.addEventListener('touchend', function(e) {
        if (!dragging) return;
        dragging = false;
        const delta = e.changedTouches[0].clientX - dragStartX;
        if (delta < -50) goTo(current + 1);
        else if (delta > 50) goTo(current - 1);
        else render(true);
    });
    window.__igOpenZoom = openZoom;
})();
(async () => {
    const {
        onElement
    } = await window.igImport('observe-dom@1');
    onElement('[id^="shopify-section-"] .stroller-product-images__media', (el) => {
        if (el.tagName !== 'IMG' || el.dataset.igZoom) return;
        el.dataset.igZoom = '1';
        el.style.cursor = 'zoom-in';
        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const wrapper = el.closest('.stroller-product-images');
            const mediaEls = wrapper ? Array.from(wrapper.querySelectorAll('.stroller-product-images__media')).filter((m) => m.tagName === 'IMG') : [el];
            const srcs = mediaEls.map((m) => m.currentSrc || m.src);
            const idx = mediaEls.indexOf(el);
            if (window.__igOpenZoom) window.__igOpenZoom(srcs, idx < 0 ? 0 : idx);
        });
    });
})();